import React, { Component } from 'react';
import { connect } from 'react-redux';

import ActionButton from 'components/buttons/action-button/ActionButton';
import { Form, FormField } from 'components/form';
import Input from 'components/inputs/input/Input';
import { ModalFrame, ModalFrameFooter, ModalFrameInner, ModalOpener } from 'components/modal';

import { changePassword } from '../../reducers/changePassword';
import { closeNotification } from 'redux-store/reducers/common-reducer';

import { equals, isNotEmpty, isValidPassword } from 'utils/validators';
import { __t, applyTranslations } from 'utils/language';

applyTranslations(require('./change-password-modal.i18n.json'));

import type { Account } from 'types';

type OwnProps = {
  open: boolean,
  onClose: () => void
};

type StateProps = {
  user: Account
};

type Props = OwnProps & StateProps & {
  dispatch: any
};

type State = {
  oldPassword: string,
  newPassword: string,
  newPasswordConfirmation: string
};

class ChangePasswordModal extends Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = this.getDefaultState();
  }

  getDefaultState() {
    return {
      oldPassword: '',
      newPassword: '',
      newPasswordConfirmation: ''
    };
  }

  handleTextInput = (value, fieldName) => {
    this.setState<any>({
      [fieldName]: value
    });
  };

  handleChangePassword = () => {
    const { dispatch, user } = this.props;
    const payload = {
      password: this.state.newPassword,
      currentPassword: this.state.oldPassword
    };

    dispatch(changePassword(user.id, payload))
      .then(this.handleClose.bind(this, { keepNotification: true }));
  };

  handleClose = (params?: { keepNotification: boolean }) => {
    const { keepNotification } = params ?? {};
    const { onClose, dispatch } = this.props;

    this.setState(this.getDefaultState());
    if (!keepNotification) {
      dispatch(closeNotification());
    }

    onClose();
  };

  render() {
    const { open } = this.props;
    const state = this.state;

    return (
      <ModalOpener
        open={open}
        onClose={this.handleClose}
      >
        <ModalFrame
          title={__t('change_password_modal.header_title')}
        >
          <ModalFrameInner
            narrowContent
          >
            <Form onSubmit={this.handleChangePassword}>
              <FormField
                label={__t('change_password_modal.current_password')}
                labelType="highlighted"
                direction="column"
                fontSize="small"
                showRequiredMark
                showValidationIcon={false}
                validators={[
                  isNotEmpty(state.oldPassword)
                ]}
              >
                <Input
                  type="password"
                  width="responsive"
                  value={state.oldPassword}
                  onChange={(evt) => this.handleTextInput(evt.target.value, 'oldPassword')}
                  data={{ qa: 'change-password-current' }}
                />
              </FormField>

              <FormField
                label={__t('change_password_modal.new_password')}
                labelType="highlighted"
                helpNote={__t('change_password_modal.password_should_be_strong_comment')}
                direction="column"
                fontSize="small"
                showRequiredMark
                showValidationIcon={false}
                validators={[
                  isNotEmpty(state.newPassword),
                  isValidPassword(state.newPassword)
                ]}
              >
                <Input
                  type="password"
                  width="responsive"
                  value={state.newPassword}
                  onChange={(evt) => this.handleTextInput(evt.target.value, 'newPassword')}
                  data={{ qa: 'change-password-new' }}
                />
              </FormField>

              <FormField
                label={__t('change_password_modal.confirm_new_password')}
                labelType="highlighted"
                direction="column"
                fontSize="small"
                showRequiredMark
                showValidationIcon={false}
                validators={[
                  isNotEmpty(state.newPasswordConfirmation),
                  equals(
                    state.newPassword,
                    state.newPasswordConfirmation,
                    __t('change_password_modal.password_does_not_match')
                  )
                ]}
              >
                <Input
                  type="password"
                  width="responsive"
                  value={state.newPasswordConfirmation}
                  onChange={
                    evt => this.handleTextInput(evt.target.value, 'newPasswordConfirmation')
                  }
                  data={{ qa: 'change-password-confirmation' }}
                />
              </FormField>
              <ModalFrameFooter>
                <ActionButton
                  color="tertiary"
                  onClick={this.handleClose}
                  data={{ qa: 'change-password__button-cancel' }}
                >
                  {__t('change_password_modal.action_button_cancel')}
                </ActionButton>
                <ActionButton
                  type="submit"
                  data={{ qa: 'change-password__button-submit' }}
                >
                  {__t('change_password_modal.change_password_action_button')}
                </ActionButton>
              </ModalFrameFooter>
            </Form>
          </ModalFrameInner>
        </ModalFrame>
      </ModalOpener>
    );
  }
}

function mapStateToProps(state): StateProps {
  return {
    user: state.account.currentAccount
  };
}

export default connect(mapStateToProps)(ChangePasswordModal);
